import StorageProvider from './storage_provider'

export default class LocalStorageProviderSingleton {
  static instance = null

  constructor() {
    throw new Error('This class is Singleton')
  }

  static getInstance() {
    if (LocalStorageProviderSingleton.instance === null) {
      LocalStorageProviderSingleton.instance = new StorageProvider(window.localStorage)
    }
    return LocalStorageProviderSingleton.instance
  }
}
